import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import {
  CalendarDays, MessageCircle, Heart, User, LogOut, Menu, X,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from '../Auth/AuthModal';
import logoShynea from '../../assets/logo-shynea.png';
import './Header.css';

const PRESTA_URL = 'https://prestation.shynea.one';

function Header() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);

  const closeMenus = () => {
    setMenuOpen(false);
    setShowAccountMenu(false);
  };

  const handleLogout = () => {
    logout();
    closeMenus();
    navigate('/');
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.account-dropdown')) {
        setShowAccountMenu(false);
      }
    };
    if (showAccountMenu) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showAccountMenu]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const initials = (() => {
    const a = (user?.first_name || user?.firstname || '').charAt(0);
    const b = (user?.last_name || user?.lastname || '').charAt(0);
    const s = `${a}${b}`.toUpperCase();
    return s || (user?.phone || '?').slice(-2);
  })();

  return (
    <>
      <header className="header">
        <div className="header-container">
          <Link to="/" className="logo" onClick={closeMenus}>
            <span className="logo-mark">
              <img src={logoShynea} alt="" className="logo-mark-img" />
            </span>
            <span className="logo-word">Shynea</span>
          </Link>

          <button
            type="button"
            className={`menu-toggle ${menuOpen ? 'is-open' : ''}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

          <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
            {user ? (
              <>
                <NavLink to="/" end className="nav-link" onClick={closeMenus}>
                  Accueil
                </NavLink>
                <NavLink to="/reservations" className="nav-link" onClick={closeMenus}>
                  <CalendarDays size={16} strokeWidth={2} />
                  Réservations
                </NavLink>
                <NavLink to="/messages" className="nav-link" onClick={closeMenus}>
                  <MessageCircle size={16} strokeWidth={2} />
                  Messages
                </NavLink>
                <NavLink to="/favoris" className="nav-link" onClick={closeMenus}>
                  <Heart size={16} strokeWidth={2} />
                  Favoris
                </NavLink>

                <div className="account-dropdown">
                  <button
                    type="button"
                    className="account-pill"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowAccountMenu((v) => !v);
                    }}
                  >
                    <span className="account-avatar">{initials}</span>
                    <span className="account-label">Compte</span>
                  </button>

                  {showAccountMenu && (
                    <div className="dropdown-menu">
                      <Link to="/profil" className="dropdown-item" onClick={closeMenus}>
                        <User size={16} />
                        Mon profil
                      </Link>
                      <button type="button" className="dropdown-item logout" onClick={handleLogout}>
                        <LogOut size={16} />
                        Déconnexion
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <NavLink to="/" end className="nav-link" onClick={closeMenus}>
                  Accueil
                </NavLink>
                <NavLink to="/salons" className="nav-link" onClick={closeMenus}>
                  Salons
                </NavLink>
                <a
                  href={PRESTA_URL}
                  className="nav-link nav-link-muted"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMenus}
                >
                  Espace pro
                </a>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    setShowAuthModal(true);
                    setMenuOpen(false);
                  }}
                >
                  Se connecter
                </button>
              </>
            )}
          </nav>
        </div>
      </header>

      {menuOpen && (
        <button
          type="button"
          className="nav-backdrop"
          aria-label="Fermer"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onSuccess={() => {
          setShowAuthModal(false);
          setMenuOpen(false);
        }}
      />
    </>
  );
}

export default Header;
